import { useState, useEffect } from 'react';
import { ButtonProps } from '@mui/material/Button';
import useDI from 'hooks/useDI';
import DIContainer from 'services/DIContainer';
import { LoadingButton } from '@mui/lab';
import useIsMountedRef from 'hooks/useIsMountedRef';
import IModelActionsService from 'services/storageModelActions/IModelActionsService';
import NavigateFrontendUtils from 'utils/NavigateFrontend';

type Props = ButtonProps & {
  lastLoadedPage: number;
  totalPages: number;
  MODEL_NAME: DIContainer.ModelsWithActionServices;
  dto?: Record<string, any> | null;
  filterOptions?: LocationSearchObjectOptions;
  listPath?: string;
  /** Параметр поиска, который всегда будет применяться */
  initialFilter?: LocationSearchObject;
};

// Плохо сделано, не ставит номер страницы в адрес (если ставить, то будет тригериться хук на подгрузку данных, которые ставит флаг isLoading у сущности, а нам этого не надо)
export default function BackgroundListLoaderButton({
  lastLoadedPage,
  totalPages,
  dto,
  MODEL_NAME,
  filterOptions,
  listPath,
  initialFilter,
}: Props) {
  const { storageActions, services } = useDI();
  const translate = services.language.translate;
  const isMountedRef = useIsMountedRef();
  const [isLoading, setIsLoading] = useState(false);
  const [actualPage, setActualPage] = useState(lastLoadedPage);

  useEffect(() => {
    if (actualPage === lastLoadedPage) {
      return;
    }

    setIsLoading(true);
    const storageActionsService = storageActions.requestScope[MODEL_NAME]() as IModelActionsService<any, any, any>;
    const filter = NavigateFrontendUtils.getLocationSearchObjectFromCurrentLocation(filterOptions);
    storageActionsService.concatListPageBackground(actualPage, dto, filter, listPath).then(() => {
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    });

    return storageActionsService.cancelListRequest();
  }, [actualPage]);

  if (initialFilter) {
    console.error('InitialFilter not implemented');
    return null;
  }

  if (totalPages <= lastLoadedPage) {
    return null;
  }

  return (
    <LoadingButton variant="contained" loading={isLoading} onClick={() => setActualPage(lastLoadedPage + 1)}>
      {translate('buttons.loadMore')}
    </LoadingButton>
  );
}
